import * as React from "react";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {DATA_STATE, useUserDashboardData} from "../../contexts/UsersDashboardContext";
import {BarChart, BarChartRow} from "../../../locations/marketing/charts/BarChart";
import {Legend, LegendItem} from "../../../components/charts/Legend";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {Display} from "../../../components/Display";
import {Loader} from "../../../components/Utils/loader/Loader";
import {EmptyState, icons, infoIcons} from "@vebox/etui-core";
import {ChartTexts, createBarChartData, getLegend} from "../../../types/UsersManagementTypes";
import AutoSizer from "react-virtualized-auto-sizer";

declare var AppTranslations: AppTranslations;

export const UsersAccessesByDay: React.FC = () => {
    const usersAccessesByDayState = useUserDashboardData().usersAccessesByDayState;

    const usrMngTexts = AppTranslations.usersManagement;
    const texts: ChartTexts = {
        usersLogging: usrMngTexts.usersLogging,
        usersLoggingByDayTitle: usrMngTexts.usersLoggingByDayTitle,
        noDataAvailable: AppTranslations.noDataAvailable,
        checkFiltersMessage: AppTranslations.miscellaneous.checkFiltersMessage,
        errorTitle: AppTranslations.errorMessages.errorTitle,
        tryAgainLaterMessage: AppTranslations.errorMessages.tryAgainLaterMessage
    }


    const [barChartData, setBarChartData] = React.useState<BarChartRow[]>([])
    const [legendItems, setLegendItems] = React.useState<LegendItem[]>([]);
    const [selectedElement, setSelectedElement] = React.useState();
    const [isEmpty, setIsEmpty] = React.useState(false);
    const {userAccessesByDayData, state} = usersAccessesByDayState;

    React.useEffect(() => {
        if (state === DATA_STATE.loaded) {
            if (userAccessesByDayData.usersLogging.length === 0 && userAccessesByDayData.usersNotLogging === 0) {
                setIsEmpty(true);
            } else {
                setBarChartData(createBarChartData(userAccessesByDayData.usersLogging))
                setLegendItems(getLegend(texts.usersLogging))
                setIsEmpty(false);
            }
        }
    }, [userAccessesByDayData]);

    return (
        <VeBoxCard className={"Section"}>
            <VeBoxCard.Header
                title={texts.usersLoggingByDayTitle}
                singleLineTitle={true}
                className={"padding-bottom-13 padding-top-13"}
            />
            <VeBoxCard.Body className={"detail-card"}>
                <Display isVisible={state === DATA_STATE.isLoading}>
                    <Loader/>
                </Display>
                <Display isVisible={state === DATA_STATE.loaded}>
                    <Display isVisible={!isEmpty}>
                        <div className="widget-content">
                            <div className="user-management-chart-legend">
                                <Legend
                                    items={legendItems}
                                    selectedItemName={selectedElement}
                                    onItemHover={setSelectedElement}
                                    showValues={false}
                                />
                            </div>
                            <AutoSizer disableHeight style={{width: "auto"}}>
                                {({width}) => {
                                    return (
                                        <BarChart
                                            width={width}
                                            height={455}
                                            color={null}
                                            data={barChartData}
                                            yUnitOfMeasure={""}
                                            minYScaleValue={4}
                                            onPathOver={setSelectedElement}
                                            selectedItem={selectedElement}
                                            labelsOptions={{externalLegend: true}}
                                        />
                                    )
                                }
                                }
                            </AutoSizer>
                        </div>
                    </Display>
                    <Display isVisible={isEmpty}>
                        <div className={"vertical-align-center"}>
                            <EmptyState>
                                <EmptyState.InfoIcon
                                    styles={{
                                        root: {
                                            color: "var(--empty-indicator-svg-stroke)",
                                        }
                                    }}
                                    glyph={infoIcons.NoContent}
                                />
                                <EmptyState.Title color="var(--empty-indicator-title-color)">{texts.noDataAvailable}</EmptyState.Title>
                                <EmptyState.SubTitle color="var(--empty-indicator-subtitle-color)">{texts.checkFiltersMessage}</EmptyState.SubTitle>
                            </EmptyState>
                        </div>
                    </Display>
                </Display>
                <Display isVisible={state === DATA_STATE.error}>
                    <EmptyState>
                        <EmptyState.Icon size={144} glyph={icons.ERROR_CIRCLE}/>
                        <EmptyState.Title color="var(--empty-indicator-title-color)">{texts.errorTitle}</EmptyState.Title>
                        <EmptyState.SubTitle color="inherit">
                            {texts.tryAgainLaterMessage}
                        </EmptyState.SubTitle>
                    </EmptyState>
                </Display>
            </VeBoxCard.Body>
        </VeBoxCard>
    )
}